import { render } from "./IrinoxDialogDark.vue?vue&type=template&id=5309ab5b"
import script from "./IrinoxDialogDark.vue?vue&type=script&lang=js"
export * from "./IrinoxDialogDark.vue?vue&type=script&lang=js"

import "./IrinoxDialogDark.vue?vue&type=style&index=0&id=5309ab5b&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__